import { Box, Divider, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

import ApiEndpointField from './ApiEndpointField';
import TeEndpointField from './TeEndpointField';
import type { OrganizationUpdateRequest } from '@/actions/org';

interface EndpointsFieldsProps {
  values: OrganizationUpdateRequest;
  setValue: <K extends keyof OrganizationUpdateRequest>(
    key: K,
    value: OrganizationUpdateRequest[K],
  ) => void;
  setChanged: () => void;
  errors: Partial<Record<keyof OrganizationUpdateRequest, string>>;
}

function EndpointsFields({
  values,
  setValue,
  setChanged,
  errors,
}: EndpointsFieldsProps): React.JSX.Element {
  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant='h6' sx={{ mt: 3 }}>
        Endpoints
      </Typography>
      <Divider sx={{ my: 2 }} />

      <Grid container spacing={2}>
        <Grid size={12}>
          <ApiEndpointField
            value={values.api_endpoint ?? ''}
            error={errors.api_endpoint}
            setValue={(v) => {
              setValue('api_endpoint', v);
              setChanged();
            }}
          />
        </Grid>
        <Grid size={12}>
          <TeEndpointField
            value={values.te_endpoint ?? ''}
            error={errors.te_endpoint}
            setValue={(v) => {
              setValue('te_endpoint', v);
              setChanged();
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default EndpointsFields;

